import Chart from "chart.js/auto"

document.addEventListener("DOMContentLoaded", () => {
    const el = document.getElementById("chartvisual")

    if (el) {
        new Chart(el, JSON.parse(el.dataset.chart))
    }
})